$mol_icon_archive_arrow_up $mol_icon path \M4 21H20V8H4M14 15V18H10V15H7L12 10L17 15M3 3H21V7H3
